if (!customElements.get('collapsible-description')) {
  customElements.define(
    'collapsible-description',
    class CollapsibleDescription extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector('[data-collapsible-content]');
        this.toggle = this.querySelector('[data-collapsible-toggle]');
        this.toggleText = this.querySelector('[data-collapsible-toggle-text]');

        if (!this.content || !this.toggle) return;

        this.toggle.addEventListener('click', this.onToggle.bind(this));
        requestAnimationFrame(this.checkOverflow.bind(this));
        window.addEventListener('resize', this.checkOverflow.bind(this));
      }

      checkOverflow() {
        if (this.hasAttribute('open')) return;
        const isOverflowing = this.content.scrollHeight > this.content.clientHeight + 1;
        this.toggle.hidden = !isOverflowing;
      }

      onToggle() {
        const isOpen = this.toggleAttribute('open');
        this.toggleText.textContent = isOpen ? 'Less' : 'More';
        this.toggle.setAttribute('aria-expanded', isOpen);
      }
    }
  );
}
